<template>
  <div>
<!-- containing scrollama object -->

<Scrollama
  :offset="0.5"
  @step-enter="stepEnterHandler"
  :progress="true"
  @step-progress="({ progress }) => (currStepProgress = progress)"  >

  
  <div id="mapContainer" class="graphicContainer" slot="graphic">
    <CurrentLegend v-if="currentMapProps && !currentMapProps.isElectric" class="legend" />
    <FutureLegend v-if="currentMapProps && currentMapProps.isElectric" class="legend" />
    <div  class="graphic">
      <FlipState id="flipper" class="graphic" v-bind="currentMapProps"/>     
    </div>
          <div ref="theFixer" v-if="!showNarrative[currentStep] && currentStep < steps.length && getNarrative(currentStep).length"  class="fixer narrative" >
        {{getNarrative(currentStep)}}
      </div>
          
  </div>


  <div class="step mystep" :data-step="k" v-for="k in steps">
    <div :class="classes(k)" :ref="`narr-${k}`">
      {{getNarrative(k)}}
    </div>
  </div>
  <div class="filler" :data-step="steps.length+1"/>

    </Scrollama>

  </div>
</template>

<script>
import Scrollama from 'vue-scrollama'
import FlipState from '@/components/FlipState'
import CurrentLegend from '@/components/CurrentLegend'
import FutureLegend from '@/components/FutureLegend'
import {mapStepProps} from '@/mapstates.js'

export default {
  props:{
    content: Object
  },
  components: {
    Scrollama,
    FlipState,
    CurrentLegend,
    FutureLegend,
  },
  data() {
    return {
      currentStep: 0, // tracks current step and informs computed property. changed when step changes
      mapStepProps,
    }
  },
  methods: {
    getNarrative(id){
      let myN = this.content.narrative
      if(myN)
        return myN[Math.min(id,myN.length-1)]
      return null
    },   
    stepEnterHandler({ element, index, direction }) {
      // called every time the step is updated. Updates data object.
      this.currentStep = index
    },
    classes(k){
      let imNew = this.showNarrative[k]
      let imPrevious = k==this.currentStep-1
      let fixerIncoming = imPrevious && !this.showNarrative[this.currentStep]
      let fixerOutgoing = imPrevious && this.showNarrative[this.currentStep]
      let hideMe = ((!imNew) || fixerIncoming)
      return {'narrative':true,              
              'hidden': (this.getNarrative(k).length==0) || ((hideMe && !fixerOutgoing) && !(this.currentStep > this.content.narrative.length))
             }
    }    
  },
  computed: {
    
    currentMapProps() {
      // this updates based on the currentStep data parameter and is what is ultimately passed to the component
      return Object.values(this.mapStepProps)[Math.min(this.currentStep,Object.keys(this.mapStepProps).length-1)]
    },
    steps(){
      return [...Array(Math.max(Object.keys(this.mapStepProps).length,this.content.narrative.length)+1).keys()]
    },

    showNarrative() {
      let out = this.steps.map((s)=>this.getNarrative(s))
      let visibilities = out.reduce( (acc,cur,idx)=>{ return [...acc, (cur.length===0) ? false : (idx===0 ? true : !(out[idx-1]===cur)) ] },Array())

      return visibilities      
    }
  }
}
</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>
<style lang="scss" scoped>
.stage-type {
}

.screener{
    height:100vh;
}

.legend{
    position: absolute;
    top:4vh;
    left:1vw;
}

#mapContainer{
    padding-bottom:20vh;
}

.mystep{
    height:200vh;
    z-index: -1000;
}

  .narrative {
    position:sticky;
    top:7%!important;
    left: calc(50vw - 30ch);
    font-size: calc(min(min(2.5vh,32px),2vw));
    border: 4px solid  #1e2343;
    z-index:10000;
    border-radius:6px;
    font-weight: bold;
    width:60ch!important;
    margin: 0!important;
    padding: 2vw!important;
    background-color:rgba(255,255,255,.876);
}

.fixer{
    position: fixed;
    left: calc(50vw - 30ch);
    opacity:1!important;
}

.hidden{
    opacity:0;
    visibility:hidden;
}

.customstep {
    height: 100vh; 
    z-index:-1000;    
}

</style>
